import { Component, Input } from '@angular/core';

import { HeaderData } from '../../interfaces/header-data.interface';

@Component({
    selector: 'mapp-springboard-header',
    templateUrl: './springboard-header.component.html',
    styleUrls: ['./springboard-header.component.scss'],
    standalone: false,
})
export default class SpringboardHeaderComponent {
    @Input() headerData: HeaderData;
}
